<div class="root" *ngIf="isOffline$ | async" @fadeOut>
    <certificate-card></certificate-card>
</div>
